[
  {
    "family": "Complete",
    "name_en": "Complete of order 2",
    "name_fr": "Complet d'ordre 2",
    "name_de": "Vollständiger der Ordnung 2",
    "file": "complete_2",
    "invariants": {
      "numNodes": 2,
      "numEdges": 1,
      "girth": null,
      "degSequence": [1, 1],
      "components": 1,
      "circuitRank": 0,
      "diameter": 1,
      "detAdjacency": -1
    }
  },
  {
    "family": "Complete",
    "name_en": "Complete of order 3",
    "name_fr": "Complet d'ordre 3",
    "name_de": "Vollständiger der Ordnung 3",
    "file": "complete_3",
    "invariants": {
      "numNodes": 3,
      "numEdges": 3,
      "girth": 3,
      "degSequence": [2, 2, 2],
      "components": 1,
      "circuitRank": 1,
      "diameter": 1,
      "detAdjacency": 2
    }
  },
  {
    "family": "Complete",
    "name_en": "Complete of order 4",
    "name_fr": "Complet d'ordre 4",
    "name_de": "Vollständiger der Ordnung 4",
    "file": "complete_4",
    "invariants": {
      "numNodes": 4,
      "numEdges": 6,
      "girth": 3,
      "degSequence": [3, 3, 3, 3],
      "components": 1,
      "circuitRank": 3,
      "diameter": 1,
      "detAdjacency": -3
    }
  },
  {
    "family": "Complete",
    "name_en": "Complete of order 5",
    "name_fr": "Complet d'ordre 5",
    "name_de": "Vollständiger der Ordnung 5",
    "file": "complete_5",
    "invariants": {
      "numNodes": 5,
      "numEdges": 10,
      "girth": 3,
      "degSequence": [4, 4, 4, 4, 4],
      "components": 1,
      "circuitRank": 6,
      "diameter": 1,
      "detAdjacency": 4
    }
  },
  {
    "family": "Complete",
    "name_en": "Complete of order 6",
    "name_fr": "Complet d'ordre 6",
    "name_de": "Vollständiger der Ordnung 6",
    "file": "complete_6",
    "invariants": {
      "numNodes": 6,
      "numEdges": 15,
      "girth": 3,
      "degSequence": [5, 5, 5, 5, 5, 5],
      "components": 1,
      "circuitRank": 10,
      "diameter": 1,
      "detAdjacency": -5
    }
  },
  {
    "family": "Complete",
    "name_en": "Complete of order 7",
    "name_fr": "Complet d'ordre 7",
    "name_de": "Vollständiger der Ordnung 7",
    "file": "complete_7",
    "invariants": {
      "numNodes": 7,
      "numEdges": 21,
      "girth": 3,
      "degSequence": [6, 6, 6, 6, 6, 6, 6],
      "components": 1,
      "circuitRank": 15,
      "diameter": 1,
      "detAdjacency": 6
    }
  },
  {
    "family": "Complete",
    "name_en": "Complete of order 8",
    "name_fr": "Complet d'ordre 8",
    "name_de": "Vollständiger der Ordnung 8",
    "file": "complete_8",
    "invariants": {
      "numNodes": 8,
      "numEdges": 28,
      "girth": 3,
      "degSequence": [7, 7, 7, 7, 7, 7, 7, 7],
      "components": 1,
      "circuitRank": 21,
      "diameter": 1,
      "detAdjacency": -7
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 2<sub>0</sub>",
    "name_fr": "Graphe cubique 2<sub>0</sub>",
    "name_de": "Kubischer Graph 2<sub>0</sub>",
    "file": "trivalent_2_0",
    "invariants": {
      "numNodes": 2,
      "numEdges": 3,
      "girth": 1,
      "degSequence": [3, 3],
      "components": 1,
      "circuitRank": 2,
      "diameter": 1,
      "detAdjacency": 3
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 2<sub>1</sub>",
    "name_fr": "Graphe cubique 2<sub>1</sub>",
    "name_de": "Kubischer Graph 2<sub>1</sub>",
    "file": "trivalent_2_1",
    "invariants": {
      "numNodes": 2,
      "numEdges": 3,
      "girth": 2,
      "degSequence": [3, 3],
      "components": 1,
      "circuitRank": 2,
      "diameter": 1,
      "detAdjacency": -9
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 3<sub>0</sub>",
    "name_fr": "Graphe cubique 3<sub>0</sub>",
    "name_de": "Kubischer Graph 3<sub>0</sub>",
    "file": "trivalent_3_0",
    "invariants": {
      "numNodes": 4,
      "numEdges": 6,
      "girth": 1,
      "degSequence": [3, 3, 3, 3],
      "components": 1,
      "circuitRank": 3,
      "diameter": 2,
      "detAdjacency": -12
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 3<sub>1</sub>",
    "name_fr": "Graphe cubique 3<sub>1</sub>",
    "name_de": "Kubischer Graph 3<sub>1</sub>",
    "file": "trivalent_3_1",
    "invariants": {
      "numNodes": 4,
      "numEdges": 6,
      "girth": 1,
      "degSequence": [3, 3, 3, 3],
      "components": 1,
      "circuitRank": 3,
      "diameter": 3,
      "detAdjacency": -15
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 3<sub>2</sub>",
    "name_fr": "Graphe cubique 3<sub>2</sub>",
    "name_de": "Kubischer Graph 3<sub>2</sub>",
    "file": "trivalent_3_2",
    "invariants": {
      "numNodes": 4,
      "numEdges": 6,
      "girth": 1,
      "degSequence": [3, 3, 3, 3],
      "components": 1,
      "circuitRank": 3,
      "diameter": 2,
      "detAdjacency": 12
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 3<sub>3</sub>",
    "name_fr": "Graphe cubique 3<sub>3</sub>",
    "name_de": "Kubischer Graph 3<sub>3</sub>",
    "file": "trivalent_3_3",
    "invariants": {
      "numNodes": 4,
      "numEdges": 6,
      "girth": 2,
      "degSequence": [3, 3, 3, 3],
      "components": 1,
      "circuitRank": 3,
      "diameter": 2,
      "detAdjacency": 9
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 3<sub>4</sub>",
    "name_fr": "Graphe cubique 3<sub>4</sub>",
    "name_de": "Kubischer Graph 3<sub>4</sub>",
    "file": "trivalent_3_4",
    "invariants": {
      "numNodes": 4,
      "numEdges": 6,
      "girth": 3,
      "degSequence": [3, 3, 3, 3],
      "components": 1,
      "circuitRank": 3,
      "diameter": 1,
      "detAdjacency": -3
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>0</sub>",
    "name_fr": "Graphe cubique 4<sub>0</sub>",
    "name_de": "Kubischer Graph 4<sub>0</sub>",
    "file": "trivalent_4_0",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 4,
      "detAdjacency": 36
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>1</sub>",
    "name_fr": "Graphe cubique 4<sub>1</sub>",
    "name_de": "Kubischer Graph 4<sub>1</sub>",
    "file": "trivalent_4_1",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>2</sub>",
    "name_fr": "Graphe cubique 4<sub>2</sub>",
    "name_de": "Kubischer Graph 4<sub>2</sub>",
    "file": "trivalent_4_2",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>3</sub>",
    "name_fr": "Graphe cubique 4<sub>3</sub>",
    "name_de": "Kubischer Graph 4<sub>3</sub>",
    "file": "trivalent_4_3",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>4</sub>",
    "name_fr": "Graphe cubique 4<sub>4</sub>",
    "name_de": "Kubischer Graph 4<sub>4</sub>",
    "file": "trivalent_4_4",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": 27
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>5</sub>",
    "name_fr": "Graphe cubique 4<sub>5</sub>",
    "name_de": "Kubischer Graph 4<sub>5</sub>",
    "file": "trivalent_4_5",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 5,
      "detAdjacency": 63
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>6</sub>",
    "name_fr": "Graphe cubique 4<sub>6</sub>",
    "name_de": "Kubischer Graph 4<sub>6</sub>",
    "file": "trivalent_4_6",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 4,
      "detAdjacency": -36
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>7</sub>",
    "name_fr": "Graphe cubique 4<sub>7</sub>",
    "name_de": "Kubischer Graph 4<sub>7</sub>",
    "file": "trivalent_4_7",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>8</sub>",
    "name_fr": "Graphe cubique 4<sub>8</sub>",
    "name_de": "Kubischer Graph 4<sub>8</sub>",
    "file": "trivalent_4_8",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": -81
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>9</sub>",
    "name_fr": "Graphe cubique 4<sub>9</sub>",
    "name_de": "Kubischer Graph 4<sub>9</sub>",
    "file": "trivalent_4_9",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>10</sub>",
    "name_fr": "Graphe cubique 4<sub>10</sub>",
    "name_de": "Kubischer Graph 4<sub>10</sub>",
    "file": "trivalent_4_10",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": -9
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>11</sub>",
    "name_fr": "Graphe cubique 4<sub>11</sub>",
    "name_de": "Kubischer Graph 4<sub>11</sub>",
    "file": "trivalent_4_11",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 4,
      "detAdjacency": -9
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>12</sub>",
    "name_fr": "Graphe cubique 4<sub>12</sub>",
    "name_de": "Kubischer Graph 4<sub>12</sub>",
    "file": "trivalent_4_12",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>13</sub>",
    "name_fr": "Graphe cubique 4<sub>13</sub>",
    "name_de": "Kubischer Graph 4<sub>13</sub>",
    "file": "trivalent_4_13",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 4,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>14</sub>",
    "name_fr": "Graphe cubique 4<sub>14</sub>",
    "name_de": "Kubischer Graph 4<sub>14</sub>",
    "file": "trivalent_4_14",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>15</sub>",
    "name_fr": "Graphe cubique 4<sub>15</sub>",
    "name_de": "Kubischer Graph 4<sub>15</sub>",
    "file": "trivalent_4_15",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 2,
      "detAdjacency": -9
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 4<sub>16</sub>",
    "name_fr": "Graphe cubique 4<sub>16</sub>",
    "name_de": "Kubischer Graph 4<sub>16</sub>",
    "file": "trivalent_4_16",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 3,
      "degSequence": [3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>0</sub>",
    "name_fr": "Graphe cubique 5<sub>0</sub>",
    "name_de": "Kubischer Graph 5<sub>0</sub>",
    "file": "trivalent_5_0",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": -48
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>1</sub>",
    "name_fr": "Graphe cubique 5<sub>1</sub>",
    "name_de": "Kubischer Graph 5<sub>1</sub>",
    "file": "trivalent_5_1",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 6,
      "detAdjacency": -132
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>2</sub>",
    "name_fr": "Graphe cubique 5<sub>2</sub>",
    "name_de": "Kubischer Graph 5<sub>2</sub>",
    "file": "trivalent_5_2",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 6,
      "detAdjacency": -96
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>3</sub>",
    "name_fr": "Graphe cubique 5<sub>3</sub>",
    "name_de": "Kubischer Graph 5<sub>3</sub>",
    "file": "trivalent_5_3",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": 24
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>4</sub>",
    "name_fr": "Graphe cubique 5<sub>4</sub>",
    "name_de": "Kubischer Graph 5<sub>4</sub>",
    "file": "trivalent_5_4",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 48
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>5</sub>",
    "name_fr": "Graphe cubique 5<sub>5</sub>",
    "name_de": "Kubischer Graph 5<sub>5</sub>",
    "file": "trivalent_5_5",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -15
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>6</sub>",
    "name_fr": "Graphe cubique 5<sub>6</sub>",
    "name_de": "Kubischer Graph 5<sub>6</sub>",
    "file": "trivalent_5_6",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": -48
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>7</sub>",
    "name_fr": "Graphe cubique 5<sub>7</sub>",
    "name_de": "Kubischer Graph 5<sub>7</sub>",
    "file": "trivalent_5_7",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": 48
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>8</sub>",
    "name_fr": "Graphe cubique 5<sub>8</sub>",
    "name_de": "Kubischer Graph 5<sub>8</sub>",
    "file": "trivalent_5_8",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -84
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>9</sub>",
    "name_fr": "Graphe cubique 5<sub>9</sub>",
    "name_de": "Kubischer Graph 5<sub>9</sub>",
    "file": "trivalent_5_9",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 96
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>10</sub>",
    "name_fr": "Graphe cubique 5<sub>10</sub>",
    "name_de": "Kubischer Graph 5<sub>10</sub>",
    "file": "trivalent_5_10",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>11</sub>",
    "name_fr": "Graphe cubique 5<sub>11</sub>",
    "name_de": "Kubischer Graph 5<sub>11</sub>",
    "file": "trivalent_5_11",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": -12
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>12</sub>",
    "name_fr": "Graphe cubique 5<sub>12</sub>",
    "name_de": "Kubischer Graph 5<sub>12</sub>",
    "file": "trivalent_5_12",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": -48
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>13</sub>",
    "name_fr": "Graphe cubique 5<sub>13</sub>",
    "name_de": "Kubischer Graph 5<sub>13</sub>",
    "file": "trivalent_5_13",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": -99
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>14</sub>",
    "name_fr": "Graphe cubique 5<sub>14</sub>",
    "name_de": "Kubischer Graph 5<sub>14</sub>",
    "file": "trivalent_5_14",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -24
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>15</sub>",
    "name_fr": "Graphe cubique 5<sub>15</sub>",
    "name_de": "Kubischer Graph 5<sub>15</sub>",
    "file": "trivalent_5_15",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -96
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>16</sub>",
    "name_fr": "Graphe cubique 5<sub>16</sub>",
    "name_de": "Kubischer Graph 5<sub>16</sub>",
    "file": "trivalent_5_16",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -36
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>17</sub>",
    "name_fr": "Graphe cubique 5<sub>17</sub>",
    "name_de": "Kubischer Graph 5<sub>17</sub>",
    "file": "trivalent_5_17",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 7,
      "detAdjacency": -255
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>18</sub>",
    "name_fr": "Graphe cubique 5<sub>18</sub>",
    "name_de": "Kubischer Graph 5<sub>18</sub>",
    "file": "trivalent_5_18",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 6,
      "detAdjacency": 132
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>19</sub>",
    "name_fr": "Graphe cubique 5<sub>19</sub>",
    "name_de": "Kubischer Graph 5<sub>19</sub>",
    "file": "trivalent_5_19",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": -24
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>20</sub>",
    "name_fr": "Graphe cubique 5<sub>20</sub>",
    "name_de": "Kubischer Graph 5<sub>20</sub>",
    "file": "trivalent_5_20",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -3
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>21</sub>",
    "name_fr": "Graphe cubique 5<sub>21</sub>",
    "name_de": "Kubischer Graph 5<sub>21</sub>",
    "file": "trivalent_5_21",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -3
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>22</sub>",
    "name_fr": "Graphe cubique 5<sub>22</sub>",
    "name_de": "Kubischer Graph 5<sub>22</sub>",
    "file": "trivalent_5_22",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": -12
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>23</sub>",
    "name_fr": "Graphe cubique 5<sub>23</sub>",
    "name_de": "Kubischer Graph 5<sub>23</sub>",
    "file": "trivalent_5_23",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -48
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>24</sub>",
    "name_fr": "Graphe cubique 5<sub>24</sub>",
    "name_de": "Kubischer Graph 5<sub>24</sub>",
    "file": "trivalent_5_24",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>25</sub>",
    "name_fr": "Graphe cubique 5<sub>25</sub>",
    "name_de": "Kubischer Graph 5<sub>25</sub>",
    "file": "trivalent_5_25",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 12
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>26</sub>",
    "name_fr": "Graphe cubique 5<sub>26</sub>",
    "name_de": "Kubischer Graph 5<sub>26</sub>",
    "file": "trivalent_5_26",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": -48
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>27</sub>",
    "name_fr": "Graphe cubique 5<sub>27</sub>",
    "name_de": "Kubischer Graph 5<sub>27</sub>",
    "file": "trivalent_5_27",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 225
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>28</sub>",
    "name_fr": "Graphe cubique 5<sub>28</sub>",
    "name_de": "Kubischer Graph 5<sub>28</sub>",
    "file": "trivalent_5_28",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 36
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>29</sub>",
    "name_fr": "Graphe cubique 5<sub>29</sub>",
    "name_de": "Kubischer Graph 5<sub>29</sub>",
    "file": "trivalent_5_29",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": 33
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>30</sub>",
    "name_fr": "Graphe cubique 5<sub>30</sub>",
    "name_de": "Kubischer Graph 5<sub>30</sub>",
    "file": "trivalent_5_30",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 105
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>31</sub>",
    "name_fr": "Graphe cubique 5<sub>31</sub>",
    "name_de": "Kubischer Graph 5<sub>31</sub>",
    "file": "trivalent_5_31",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -12
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>32</sub>",
    "name_fr": "Graphe cubique 5<sub>32</sub>",
    "name_de": "Kubischer Graph 5<sub>32</sub>",
    "file": "trivalent_5_32",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 6,
      "detAdjacency": 21
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>33</sub>",
    "name_fr": "Graphe cubique 5<sub>33</sub>",
    "name_de": "Kubischer Graph 5<sub>33</sub>",
    "file": "trivalent_5_33",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -24
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>34</sub>",
    "name_fr": "Graphe cubique 5<sub>34</sub>",
    "name_de": "Kubischer Graph 5<sub>34</sub>",
    "file": "trivalent_5_34",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 9
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>35</sub>",
    "name_fr": "Graphe cubique 5<sub>35</sub>",
    "name_de": "Kubischer Graph 5<sub>35</sub>",
    "file": "trivalent_5_35",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 9
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>36</sub>",
    "name_fr": "Graphe cubique 5<sub>36</sub>",
    "name_de": "Kubischer Graph 5<sub>36</sub>",
    "file": "trivalent_5_36",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>37</sub>",
    "name_fr": "Graphe cubique 5<sub>37</sub>",
    "name_de": "Kubischer Graph 5<sub>37</sub>",
    "file": "trivalent_5_37",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -3
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>38</sub>",
    "name_fr": "Graphe cubique 5<sub>38</sub>",
    "name_de": "Kubischer Graph 5<sub>38</sub>",
    "file": "trivalent_5_38",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>39</sub>",
    "name_fr": "Graphe cubique 5<sub>39</sub>",
    "name_de": "Kubischer Graph 5<sub>39</sub>",
    "file": "trivalent_5_39",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>40</sub>",
    "name_fr": "Graphe cubique 5<sub>40</sub>",
    "name_de": "Kubischer Graph 5<sub>40</sub>",
    "file": "trivalent_5_40",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>41</sub>",
    "name_fr": "Graphe cubique 5<sub>41</sub>",
    "name_de": "Kubischer Graph 5<sub>41</sub>",
    "file": "trivalent_5_41",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -3
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>42</sub>",
    "name_fr": "Graphe cubique 5<sub>42</sub>",
    "name_de": "Kubischer Graph 5<sub>42</sub>",
    "file": "trivalent_5_42",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>43</sub>",
    "name_fr": "Graphe cubique 5<sub>43</sub>",
    "name_de": "Kubischer Graph 5<sub>43</sub>",
    "file": "trivalent_5_43",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 4,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 9
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>44</sub>",
    "name_fr": "Graphe cubique 5<sub>44</sub>",
    "name_de": "Kubischer Graph 5<sub>44</sub>",
    "file": "trivalent_5_44",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>45</sub>",
    "name_fr": "Graphe cubique 5<sub>45</sub>",
    "name_de": "Kubischer Graph 5<sub>45</sub>",
    "file": "trivalent_5_45",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -15
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>46</sub>",
    "name_fr": "Graphe cubique 5<sub>46</sub>",
    "name_de": "Kubischer Graph 5<sub>46</sub>",
    "file": "trivalent_5_46",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 144
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>47</sub>",
    "name_fr": "Graphe cubique 5<sub>47</sub>",
    "name_de": "Kubischer Graph 5<sub>47</sub>",
    "file": "trivalent_5_47",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": -48
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>48</sub>",
    "name_fr": "Graphe cubique 5<sub>48</sub>",
    "name_de": "Kubischer Graph 5<sub>48</sub>",
    "file": "trivalent_5_48",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -3
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>49</sub>",
    "name_fr": "Graphe cubique 5<sub>49</sub>",
    "name_de": "Kubischer Graph 5<sub>49</sub>",
    "file": "trivalent_5_49",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>50</sub>",
    "name_fr": "Graphe cubique 5<sub>50</sub>",
    "name_de": "Kubischer Graph 5<sub>50</sub>",
    "file": "trivalent_5_50",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": -15
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>51</sub>",
    "name_fr": "Graphe cubique 5<sub>51</sub>",
    "name_de": "Kubischer Graph 5<sub>51</sub>",
    "file": "trivalent_5_51",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": -12
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>52</sub>",
    "name_fr": "Graphe cubique 5<sub>52</sub>",
    "name_de": "Kubischer Graph 5<sub>52</sub>",
    "file": "trivalent_5_52",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 36
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>53</sub>",
    "name_fr": "Graphe cubique 5<sub>53</sub>",
    "name_de": "Kubischer Graph 5<sub>53</sub>",
    "file": "trivalent_5_53",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 24
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>54</sub>",
    "name_fr": "Graphe cubique 5<sub>54</sub>",
    "name_de": "Kubischer Graph 5<sub>54</sub>",
    "file": "trivalent_5_54",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 96
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>55</sub>",
    "name_fr": "Graphe cubique 5<sub>55</sub>",
    "name_de": "Kubischer Graph 5<sub>55</sub>",
    "file": "trivalent_5_55",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 36
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>56</sub>",
    "name_fr": "Graphe cubique 5<sub>56</sub>",
    "name_de": "Kubischer Graph 5<sub>56</sub>",
    "file": "trivalent_5_56",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 48
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>57</sub>",
    "name_fr": "Graphe cubique 5<sub>57</sub>",
    "name_de": "Kubischer Graph 5<sub>57</sub>",
    "file": "trivalent_5_57",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 5,
      "detAdjacency": 12
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>58</sub>",
    "name_fr": "Graphe cubique 5<sub>58</sub>",
    "name_de": "Kubischer Graph 5<sub>58</sub>",
    "file": "trivalent_5_58",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>59</sub>",
    "name_fr": "Graphe cubique 5<sub>59</sub>",
    "name_de": "Kubischer Graph 5<sub>59</sub>",
    "file": "trivalent_5_59",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 1,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 21
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>60</sub>",
    "name_fr": "Graphe cubique 5<sub>60</sub>",
    "name_de": "Kubischer Graph 5<sub>60</sub>",
    "file": "trivalent_5_60",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": -15
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>61</sub>",
    "name_fr": "Graphe cubique 5<sub>61</sub>",
    "name_de": "Kubischer Graph 5<sub>61</sub>",
    "file": "trivalent_5_61",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 48
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>62</sub>",
    "name_fr": "Graphe cubique 5<sub>62</sub>",
    "name_de": "Kubischer Graph 5<sub>62</sub>",
    "file": "trivalent_5_62",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>63</sub>",
    "name_fr": "Graphe cubique 5<sub>63</sub>",
    "name_de": "Kubischer Graph 5<sub>63</sub>",
    "file": "trivalent_5_63",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 9
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>64</sub>",
    "name_fr": "Graphe cubique 5<sub>64</sub>",
    "name_de": "Kubischer Graph 5<sub>64</sub>",
    "file": "trivalent_5_64",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 4,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 2,
      "detAdjacency": -3
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>65</sub>",
    "name_fr": "Graphe cubique 5<sub>65</sub>",
    "name_de": "Kubischer Graph 5<sub>65</sub>",
    "file": "trivalent_5_65",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 12
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>66</sub>",
    "name_fr": "Graphe cubique 5<sub>66</sub>",
    "name_de": "Kubischer Graph 5<sub>66</sub>",
    "file": "trivalent_5_66",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>67</sub>",
    "name_fr": "Graphe cubique 5<sub>67</sub>",
    "name_de": "Kubischer Graph 5<sub>67</sub>",
    "file": "trivalent_5_67",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 3,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 9
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>68</sub>",
    "name_fr": "Graphe cubique 5<sub>68</sub>",
    "name_de": "Kubischer Graph 5<sub>68</sub>",
    "file": "trivalent_5_68",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 3,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": -15
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>69</sub>",
    "name_fr": "Graphe cubique 5<sub>69</sub>",
    "name_de": "Kubischer Graph 5<sub>69</sub>",
    "file": "trivalent_5_69",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 3,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Trivalent",
    "name_en": "Trivalent 5<sub>70</sub>",
    "name_fr": "Graphe cubique 5<sub>70</sub>",
    "name_de": "Kubischer Graph 5<sub>70</sub>",
    "file": "trivalent_5_70",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 2,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 4,
      "detAdjacency": -12
    }
  },
  {
    "family": "Special",
    "name_en": "Königsberg",
    "name_fr": "Königsberg",
    "name_de": "Königsberg",
    "file": "konigsberg",
    "invariants": {
      "numNodes": 4,
      "numEdges": 7,
      "girth": 2,
      "degSequence": [5, 3, 3, 3],
      "components": 1,
      "circuitRank": 4,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Platonic",
    "name_en": "Cube",
    "name_fr": "Cube",
    "name_de": "Würfel",
    "file": "cube",
    "invariants": {
      "numNodes": 8,
      "numEdges": 12,
      "girth": 4,
      "degSequence": [3, 3, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 3,
      "detAdjacency": 9
    }
  },
  {
    "family": "Platonic",
    "name_en": "Octahedron",
    "name_fr": "Octaèdre",
    "name_de": "Oktaeder",
    "file": "octahedron",
    "invariants": {
      "numNodes": 6,
      "numEdges": 12,
      "girth": 3,
      "degSequence": [4, 4, 4, 4, 4, 4],
      "components": 1,
      "circuitRank": 7,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Other",
    "name_en": "Moser spindle",
    "name_fr": "Graphe de Moser",
    "name_de": "Moser-Spindel",
    "file": "moser_spindle",
    "invariants": {
      "numNodes": 7,
      "numEdges": 11,
      "girth": 3,
      "degSequence": [4, 3, 3, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 2,
      "detAdjacency": 12
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>0</sub>",
    "name_fr": "Graphe G<sub>0</sub>",
    "name_de": "Graph G<sub>0</sub>",
    "file": "G_0",
    "invariants": {
      "numNodes": 3,
      "numEdges": 1,
      "girth": null,
      "degSequence": [1, 1, 0],
      "components": 2,
      "circuitRank": 0,
      "diameter": null,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>1</sub>",
    "name_fr": "Graphe G<sub>1</sub>",
    "name_de": "Graph G<sub>1</sub>",
    "file": "G_1",
    "invariants": {
      "numNodes": 3,
      "numEdges": 2,
      "girth": null,
      "degSequence": [2, 1, 1],
      "components": 1,
      "circuitRank": 0,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>2</sub>",
    "name_fr": "Graphe G<sub>2</sub>",
    "name_de": "Graph G<sub>2</sub>",
    "file": "G_2",
    "invariants": {
      "numNodes": 3,
      "numEdges": 3,
      "girth": 3,
      "degSequence": [2, 2, 2],
      "components": 1,
      "circuitRank": 1,
      "diameter": 1,
      "detAdjacency": 2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>3</sub>",
    "name_fr": "Graphe G<sub>3</sub>",
    "name_de": "Graph G<sub>3</sub>",
    "file": "G_3",
    "invariants": {
      "numNodes": 3,
      "numEdges": 0,
      "girth": null,
      "degSequence": [0, 0, 0],
      "components": 3,
      "circuitRank": 0,
      "diameter": null,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>4</sub>",
    "name_fr": "Graphe G<sub>4</sub>",
    "name_de": "Graph G<sub>4</sub>",
    "file": "G_4",
    "invariants": {
      "numNodes": 4,
      "numEdges": 3,
      "girth": null,
      "degSequence": [2, 2, 1, 1],
      "components": 1,
      "circuitRank": 0,
      "diameter": 3,
      "detAdjacency": 1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>5</sub>",
    "name_fr": "Graphe G<sub>5</sub>",
    "name_de": "Graph G<sub>5</sub>",
    "file": "G_5",
    "invariants": {
      "numNodes": 4,
      "numEdges": 4,
      "girth": 4,
      "degSequence": [2, 2, 2, 2],
      "components": 1,
      "circuitRank": 1,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>6</sub>",
    "name_fr": "Graphe G<sub>6</sub>",
    "name_de": "Graph G<sub>6</sub>",
    "file": "G_6",
    "invariants": {
      "numNodes": 4,
      "numEdges": 2,
      "girth": null,
      "degSequence": [1, 1, 1, 1],
      "components": 2,
      "circuitRank": 0,
      "diameter": null,
      "detAdjacency": 1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>7</sub>",
    "name_fr": "Graphe G<sub>7</sub>",
    "name_de": "Graph G<sub>7</sub>",
    "file": "G_7",
    "invariants": {
      "numNodes": 4,
      "numEdges": 2,
      "girth": null,
      "degSequence": [2, 1, 1, 0],
      "components": 2,
      "circuitRank": 0,
      "diameter": null,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>8</sub>",
    "name_fr": "Graphe G<sub>8</sub>",
    "name_de": "Graph G<sub>8</sub>",
    "file": "G_8",
    "invariants": {
      "numNodes": 4,
      "numEdges": 5,
      "girth": 3,
      "degSequence": [3, 3, 2, 2],
      "components": 1,
      "circuitRank": 2,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>9</sub>",
    "name_fr": "Graphe G<sub>9</sub>",
    "name_de": "Graph G<sub>9</sub>",
    "file": "G_9",
    "invariants": {
      "numNodes": 5,
      "numEdges": 7,
      "girth": 3,
      "degSequence": [3, 3, 3, 3, 2],
      "components": 1,
      "circuitRank": 3,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>10</sub>",
    "name_fr": "Graphe G<sub>10</sub>",
    "name_de": "Graph G<sub>10</sub>",
    "file": "G_10",
    "invariants": {
      "numNodes": 5,
      "numEdges": 6,
      "girth": 3,
      "degSequence": [3, 3, 2, 2, 2],
      "components": 1,
      "circuitRank": 2,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>11</sub>",
    "name_fr": "Graphe G<sub>11</sub>",
    "name_de": "Graph G<sub>11</sub>",
    "file": "G_11",
    "invariants": {
      "numNodes": 5,
      "numEdges": 4,
      "girth": null,
      "degSequence": [2, 2, 2, 1, 1],
      "components": 1,
      "circuitRank": 0,
      "diameter": 4,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>12</sub>",
    "name_fr": "Graphe G<sub>12</sub>",
    "name_de": "Graph G<sub>12</sub>",
    "file": "G_12",
    "invariants": {
      "numNodes": 5,
      "numEdges": 7,
      "girth": 3,
      "degSequence": [4, 4, 2, 2, 2],
      "components": 1,
      "circuitRank": 3,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>13</sub>",
    "name_fr": "Graphe G<sub>13</sub>",
    "name_de": "Graph G<sub>13</sub>",
    "file": "G_13",
    "invariants": {
      "numNodes": 5,
      "numEdges": 4,
      "girth": 3,
      "degSequence": [2, 2, 2, 1, 1],
      "components": 2,
      "circuitRank": 1,
      "diameter": null,
      "detAdjacency": -2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>14</sub>",
    "name_fr": "Graphe G<sub>14</sub>",
    "name_de": "Graph G<sub>14</sub>",
    "file": "G_14",
    "invariants": {
      "numNodes": 5,
      "numEdges": 7,
      "girth": 3,
      "degSequence": [4, 3, 3, 3, 1],
      "components": 1,
      "circuitRank": 3,
      "diameter": 2,
      "detAdjacency": -2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>15</sub>",
    "name_fr": "Graphe G<sub>15</sub>",
    "name_de": "Graph G<sub>15</sub>",
    "file": "G_15",
    "invariants": {
      "numNodes": 5,
      "numEdges": 6,
      "girth": 3,
      "degSequence": [3, 3, 3, 2, 1],
      "components": 1,
      "circuitRank": 2,
      "diameter": 3,
      "detAdjacency": -2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>16</sub>",
    "name_fr": "Graphe G<sub>16</sub>",
    "name_de": "Graph G<sub>16</sub>",
    "file": "G_16",
    "invariants": {
      "numNodes": 5,
      "numEdges": 6,
      "girth": 3,
      "degSequence": [4, 3, 2, 2, 1],
      "components": 1,
      "circuitRank": 2,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>17</sub>",
    "name_fr": "Graphe G<sub>17</sub>",
    "name_de": "Graph G<sub>17</sub>",
    "file": "G_17",
    "invariants": {
      "numNodes": 5,
      "numEdges": 9,
      "girth": 3,
      "degSequence": [4, 4, 4, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>18</sub>",
    "name_fr": "Graphe G<sub>18</sub>",
    "name_de": "Graph G<sub>18</sub>",
    "file": "G_18",
    "invariants": {
      "numNodes": 5,
      "numEdges": 8,
      "girth": 3,
      "degSequence": [4, 4, 3, 3, 2],
      "components": 1,
      "circuitRank": 4,
      "diameter": 2,
      "detAdjacency": -2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>19</sub>",
    "name_fr": "Graphe G<sub>19</sub>",
    "name_de": "Graph G<sub>19</sub>",
    "file": "G_19",
    "invariants": {
      "numNodes": 5,
      "numEdges": 7,
      "girth": 3,
      "degSequence": [4, 3, 3, 2, 2],
      "components": 1,
      "circuitRank": 3,
      "diameter": 2,
      "detAdjacency": -2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>20</sub>",
    "name_fr": "Graphe G<sub>20</sub>",
    "name_de": "Graph G<sub>20</sub>",
    "file": "G_20",
    "invariants": {
      "numNodes": 5,
      "numEdges": 5,
      "girth": 3,
      "degSequence": [4, 2, 2, 1, 1],
      "components": 1,
      "circuitRank": 1,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>21</sub>",
    "name_fr": "Graphe G<sub>21</sub>",
    "name_de": "Graph G<sub>21</sub>",
    "file": "G_21",
    "invariants": {
      "numNodes": 5,
      "numEdges": 4,
      "girth": 3,
      "degSequence": [3, 2, 2, 1, 0],
      "components": 2,
      "circuitRank": 1,
      "diameter": null,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>22</sub>",
    "name_fr": "Graphe G<sub>22</sub>",
    "name_de": "Graph G<sub>22</sub>",
    "file": "G_22",
    "invariants": {
      "numNodes": 5,
      "numEdges": 5,
      "girth": 5,
      "degSequence": [2, 2, 2, 2, 2],
      "components": 1,
      "circuitRank": 1,
      "diameter": 2,
      "detAdjacency": 2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>23</sub>",
    "name_fr": "Graphe G<sub>23</sub>",
    "name_de": "Graph G<sub>23</sub>",
    "file": "G_23",
    "invariants": {
      "numNodes": 6,
      "numEdges": 6,
      "girth": 3,
      "degSequence": [4, 3, 2, 1, 1, 1],
      "components": 1,
      "circuitRank": 1,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>24</sub>",
    "name_fr": "Graphe G<sub>24</sub>",
    "name_de": "Graph G<sub>24</sub>",
    "file": "G_24",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 3,
      "degSequence": [4, 4, 3, 3, 2, 2],
      "components": 1,
      "circuitRank": 4,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>25</sub>",
    "name_fr": "Graphe G<sub>25</sub>",
    "name_de": "Graph G<sub>25</sub>",
    "file": "G_25",
    "invariants": {
      "numNodes": 6,
      "numEdges": 11,
      "girth": 3,
      "degSequence": [5, 4, 4, 3, 3, 3],
      "components": 1,
      "circuitRank": 6,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>26</sub>",
    "name_fr": "Graphe G<sub>26</sub>",
    "name_de": "Graph G<sub>26</sub>",
    "file": "G_26",
    "invariants": {
      "numNodes": 6,
      "numEdges": 10,
      "girth": 3,
      "degSequence": [5, 4, 3, 3, 3, 2],
      "components": 1,
      "circuitRank": 5,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>27</sub>",
    "name_fr": "Graphe G<sub>27</sub>",
    "name_de": "Graph G<sub>27</sub>",
    "file": "G_27",
    "invariants": {
      "numNodes": 6,
      "numEdges": 7,
      "girth": 4,
      "degSequence": [3, 3, 3, 2, 2, 1],
      "components": 1,
      "circuitRank": 2,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>28</sub>",
    "name_fr": "Graphe G<sub>28</sub>",
    "name_de": "Graph G<sub>28</sub>",
    "file": "G_28",
    "invariants": {
      "numNodes": 6,
      "numEdges": 10,
      "girth": 3,
      "degSequence": [4, 4, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 2,
      "detAdjacency": -1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>29</sub>",
    "name_fr": "Graphe G<sub>29</sub>",
    "name_de": "Graph G<sub>29</sub>",
    "file": "G_29",
    "invariants": {
      "numNodes": 6,
      "numEdges": 6,
      "girth": 3,
      "degSequence": [3, 2, 2, 2, 2, 1],
      "components": 1,
      "circuitRank": 1,
      "diameter": 4,
      "detAdjacency": -1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>30</sub>",
    "name_fr": "Graphe G<sub>30</sub>",
    "name_de": "Graph G<sub>30</sub>",
    "file": "G_30",
    "invariants": {
      "numNodes": 6,
      "numEdges": 11,
      "girth": 3,
      "degSequence": [5, 5, 4, 3, 3, 2],
      "components": 1,
      "circuitRank": 6,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>31</sub>",
    "name_fr": "Graphe G<sub>31</sub>",
    "name_de": "Graph G<sub>31</sub>",
    "file": "G_31",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 3,
      "degSequence": [4, 4, 3, 3, 2, 2],
      "components": 1,
      "circuitRank": 4,
      "diameter": 2,
      "detAdjacency": -1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>32</sub>",
    "name_fr": "Graphe G<sub>32</sub>",
    "name_de": "Graph G<sub>32</sub>",
    "file": "G_32",
    "invariants": {
      "numNodes": 6,
      "numEdges": 7,
      "girth": 3,
      "degSequence": [3, 3, 3, 2, 2, 1],
      "components": 1,
      "circuitRank": 2,
      "diameter": 4,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>33</sub>",
    "name_fr": "Graphe G<sub>33</sub>",
    "name_de": "Graph G<sub>33</sub>",
    "file": "G_33",
    "invariants": {
      "numNodes": 6,
      "numEdges": 10,
      "girth": 3,
      "degSequence": [4, 4, 4, 3, 3, 2],
      "components": 1,
      "circuitRank": 5,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>34</sub>",
    "name_fr": "Graphe G<sub>34</sub>",
    "name_de": "Graph G<sub>34</sub>",
    "file": "G_34",
    "invariants": {
      "numNodes": 6,
      "numEdges": 8,
      "girth": 3,
      "degSequence": [4, 4, 3, 2, 2, 1],
      "components": 1,
      "circuitRank": 3,
      "diameter": 3,
      "detAdjacency": -1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>35</sub>",
    "name_fr": "Graphe G<sub>35</sub>",
    "name_de": "Graph G<sub>35</sub>",
    "file": "G_35",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 3,
      "degSequence": [4, 4, 4, 3, 2, 1],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>36</sub>",
    "name_fr": "Graphe G<sub>36</sub>",
    "name_de": "Graph G<sub>36</sub>",
    "file": "G_36",
    "invariants": {
      "numNodes": 6,
      "numEdges": 8,
      "girth": 3,
      "degSequence": [4, 3, 3, 2, 2, 2],
      "components": 1,
      "circuitRank": 3,
      "diameter": 3,
      "detAdjacency": -1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>37</sub>",
    "name_fr": "Graphe G<sub>37</sub>",
    "name_de": "Graph G<sub>37</sub>",
    "file": "G_37",
    "invariants": {
      "numNodes": 6,
      "numEdges": 8,
      "girth": 3,
      "degSequence": [3, 3, 3, 3, 2, 2],
      "components": 1,
      "circuitRank": 3,
      "diameter": 2,
      "detAdjacency": -1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>38</sub>",
    "name_fr": "Graphe G<sub>38</sub>",
    "name_de": "Graph G<sub>38</sub>",
    "file": "G_38",
    "invariants": {
      "numNodes": 6,
      "numEdges": 6,
      "girth": 4,
      "degSequence": [3, 3, 2, 2, 1, 1],
      "components": 1,
      "circuitRank": 1,
      "diameter": 4,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>39</sub>",
    "name_fr": "Graphe G<sub>39</sub>",
    "name_de": "Graph G<sub>39</sub>",
    "file": "G_39",
    "invariants": {
      "numNodes": 6,
      "numEdges": 6,
      "girth": 3,
      "degSequence": [4, 3, 2, 2, 1, 0],
      "components": 2,
      "circuitRank": 2,
      "diameter": null,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>40</sub>",
    "name_fr": "Graphe G<sub>40</sub>",
    "name_de": "Graph G<sub>40</sub>",
    "file": "G_40",
    "invariants": {
      "numNodes": 6,
      "numEdges": 13,
      "girth": 3,
      "degSequence": [5, 5, 5, 4, 4, 3],
      "components": 1,
      "circuitRank": 8,
      "diameter": 2,
      "detAdjacency": 3
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>41</sub>",
    "name_fr": "Graphe G<sub>41</sub>",
    "name_de": "Graph G<sub>41</sub>",
    "file": "G_41",
    "invariants": {
      "numNodes": 6,
      "numEdges": 8,
      "girth": 3,
      "degSequence": [4, 3, 3, 3, 2, 1],
      "components": 1,
      "circuitRank": 3,
      "diameter": 3,
      "detAdjacency": -1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>42</sub>",
    "name_fr": "Graphe G<sub>42</sub>",
    "name_de": "Graph G<sub>42</sub>",
    "file": "G_42",
    "invariants": {
      "numNodes": 6,
      "numEdges": 7,
      "girth": 3,
      "degSequence": [5, 3, 2, 2, 1, 1],
      "components": 1,
      "circuitRank": 2,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>43</sub>",
    "name_fr": "Graphe G<sub>43</sub>",
    "name_de": "Graph G<sub>43</sub>",
    "file": "G_43",
    "invariants": {
      "numNodes": 6,
      "numEdges": 10,
      "girth": 3,
      "degSequence": [4, 4, 3, 3, 3, 3],
      "components": 1,
      "circuitRank": 5,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>44</sub>",
    "name_fr": "Graphe G<sub>44</sub>",
    "name_de": "Graph G<sub>44</sub>",
    "file": "G_44",
    "invariants": {
      "numNodes": 6,
      "numEdges": 9,
      "girth": 3,
      "degSequence": [4, 4, 3, 3, 3, 1],
      "components": 1,
      "circuitRank": 4,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>45</sub>",
    "name_fr": "Graphe G<sub>45</sub>",
    "name_de": "Graph G<sub>45</sub>",
    "file": "G_45",
    "invariants": {
      "numNodes": 6,
      "numEdges": 6,
      "girth": 5,
      "degSequence": [3, 2, 2, 2, 2, 1],
      "components": 1,
      "circuitRank": 1,
      "diameter": 3,
      "detAdjacency": -1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>46</sub>",
    "name_fr": "Graphe G<sub>46</sub>",
    "name_de": "Graph G<sub>46</sub>",
    "file": "G_46",
    "invariants": {
      "numNodes": 7,
      "numEdges": 16,
      "girth": 3,
      "degSequence": [6, 5, 5, 4, 4, 4, 4],
      "components": 1,
      "circuitRank": 10,
      "diameter": 2,
      "detAdjacency": 2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>47</sub>",
    "name_fr": "Graphe G<sub>47</sub>",
    "name_de": "Graph G<sub>47</sub>",
    "file": "G_47",
    "invariants": {
      "numNodes": 7,
      "numEdges": 16,
      "girth": 3,
      "degSequence": [6, 6, 5, 4, 4, 4, 3],
      "components": 1,
      "circuitRank": 10,
      "diameter": 2,
      "detAdjacency": -6
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>48</sub>",
    "name_fr": "Graphe G<sub>48</sub>",
    "name_de": "Graph G<sub>48</sub>",
    "file": "G_48",
    "invariants": {
      "numNodes": 7,
      "numEdges": 12,
      "girth": 3,
      "degSequence": [4, 4, 4, 4, 3, 3, 2],
      "components": 1,
      "circuitRank": 6,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>49</sub>",
    "name_fr": "Graphe G<sub>49</sub>",
    "name_de": "Graph G<sub>49</sub>",
    "file": "G_49",
    "invariants": {
      "numNodes": 7,
      "numEdges": 17,
      "girth": 3,
      "degSequence": [6, 6, 5, 5, 4, 4, 4],
      "components": 1,
      "circuitRank": 11,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>50</sub>",
    "name_fr": "Graphe G<sub>50</sub>",
    "name_de": "Graph G<sub>50</sub>",
    "file": "G_50",
    "invariants": {
      "numNodes": 7,
      "numEdges": 13,
      "girth": 3,
      "degSequence": [5, 5, 4, 4, 3, 3, 2],
      "components": 1,
      "circuitRank": 7,
      "diameter": 2,
      "detAdjacency": 2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>51</sub>",
    "name_fr": "Graphe G<sub>51</sub>",
    "name_de": "Graph G<sub>51</sub>",
    "file": "G_51",
    "invariants": {
      "numNodes": 7,
      "numEdges": 13,
      "girth": 3,
      "degSequence": [5, 5, 4, 4, 3, 3, 2],
      "components": 1,
      "circuitRank": 7,
      "diameter": 3,
      "detAdjacency": 2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>52</sub>",
    "name_fr": "Graphe G<sub>52</sub>",
    "name_de": "Graph G<sub>52</sub>",
    "file": "G_52",
    "invariants": {
      "numNodes": 7,
      "numEdges": 9,
      "girth": 3,
      "degSequence": [4, 3, 3, 2, 2, 2, 2],
      "components": 1,
      "circuitRank": 3,
      "diameter": 3,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>53</sub>",
    "name_fr": "Graphe G<sub>53</sub>",
    "name_de": "Graph G<sub>53</sub>",
    "file": "G_53",
    "invariants": {
      "numNodes": 7,
      "numEdges": 15,
      "girth": 3,
      "degSequence": [6, 5, 4, 4, 4, 4, 3],
      "components": 1,
      "circuitRank": 9,
      "diameter": 2,
      "detAdjacency": 2
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>54</sub>",
    "name_fr": "Graphe G<sub>54</sub>",
    "name_de": "Graph G<sub>54</sub>",
    "file": "G_54",
    "invariants": {
      "numNodes": 7,
      "numEdges": 13,
      "girth": 3,
      "degSequence": [5, 5, 5, 3, 3, 3, 2],
      "components": 1,
      "circuitRank": 7,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>55</sub>",
    "name_fr": "Graphe G<sub>55</sub>",
    "name_de": "Graph G<sub>55</sub>",
    "file": "G_55",
    "invariants": {
      "numNodes": 8,
      "numEdges": 18,
      "girth": 3,
      "degSequence": [7, 6, 5, 4, 4, 4, 3, 3],
      "components": 1,
      "circuitRank": 11,
      "diameter": 2,
      "detAdjacency": -3
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>56</sub>",
    "name_fr": "Graphe G<sub>56</sub>",
    "name_de": "Graph G<sub>56</sub>",
    "file": "G_56",
    "invariants": {
      "numNodes": 8,
      "numEdges": 23,
      "girth": 3,
      "degSequence": [7, 7, 7, 6, 5, 5, 5, 4],
      "components": 1,
      "circuitRank": 16,
      "diameter": 2,
      "detAdjacency": 8
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>57</sub>",
    "name_fr": "Graphe G<sub>57</sub>",
    "name_de": "Graph G<sub>57</sub>",
    "file": "G_57",
    "invariants": {
      "numNodes": 8,
      "numEdges": 17,
      "girth": 3,
      "degSequence": [6, 6, 5, 5, 4, 3, 3, 2],
      "components": 1,
      "circuitRank": 10,
      "diameter": 3,
      "detAdjacency": -4
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>58</sub>",
    "name_fr": "Graphe G<sub>58</sub>",
    "name_de": "Graph G<sub>58</sub>",
    "file": "G_58",
    "invariants": {
      "numNodes": 8,
      "numEdges": 19,
      "girth": 3,
      "degSequence": [7, 5, 5, 5, 5, 4, 4, 3],
      "components": 1,
      "circuitRank": 12,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>59</sub>",
    "name_fr": "Graphe G<sub>59</sub>",
    "name_de": "Graph G<sub>59</sub>",
    "file": "G_59",
    "invariants": {
      "numNodes": 8,
      "numEdges": 20,
      "girth": 3,
      "degSequence": [7, 6, 5, 5, 5, 4, 4, 4],
      "components": 1,
      "circuitRank": 13,
      "diameter": 2,
      "detAdjacency": -4
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>60</sub>",
    "name_fr": "Graphe G<sub>60</sub>",
    "name_de": "Graph G<sub>60</sub>",
    "file": "G_60",
    "invariants": {
      "numNodes": 8,
      "numEdges": 18,
      "girth": 3,
      "degSequence": [6, 6, 5, 4, 4, 4, 4, 3],
      "components": 1,
      "circuitRank": 11,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>61</sub>",
    "name_fr": "Graphe G<sub>61</sub>",
    "name_de": "Graph G<sub>61</sub>",
    "file": "G_61",
    "invariants": {
      "numNodes": 8,
      "numEdges": 20,
      "girth": 3,
      "degSequence": [6, 6, 6, 6, 5, 4, 4, 3],
      "components": 1,
      "circuitRank": 13,
      "diameter": 2,
      "detAdjacency": 0
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>62</sub>",
    "name_fr": "Graphe G<sub>62</sub>",
    "name_de": "Graph G<sub>62</sub>",
    "file": "G_62",
    "invariants": {
      "numNodes": 8,
      "numEdges": 19,
      "girth": 3,
      "degSequence": [6, 5, 5, 5, 5, 4, 4, 4],
      "components": 1,
      "circuitRank": 12,
      "diameter": 2,
      "detAdjacency": 1
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>63</sub>",
    "name_fr": "Graphe G<sub>63</sub>",
    "name_de": "Graph G<sub>63</sub>",
    "file": "G_63",
    "invariants": {
      "numNodes": 8,
      "numEdges": 15,
      "girth": 3,
      "degSequence": [6, 5, 4, 4, 3, 3, 3, 2],
      "components": 1,
      "circuitRank": 8,
      "diameter": 3,
      "detAdjacency": -4
    }
  },
  {
    "family": "Samples",
    "name_en": "Graph G<sub>64</sub>",
    "name_fr": "Graphe G<sub>64</sub>",
    "name_de": "Graph G<sub>64</sub>",
    "file": "G_64",
    "invariants": {
      "numNodes": 8,
      "numEdges": 20,
      "girth": 3,
      "degSequence": [6, 6, 6, 5, 5, 5, 4, 3],
      "components": 1,
      "circuitRank": 13,
      "diameter": 2,
      "detAdjacency": 0
    }
  }
]
